export enum OrganizationNotificationType {
	COMPANIES_REVENUE = 'COMPANIES_REVENUE',
	WEEKLY_REVENUE = 'WEEKLY_REVENUE',
	DEACTIVATED_AND_REACTIVATED_USERS = 'DEACTIVATED_AND_REACTIVATED_USERS'
}
